import axios from './axios';
import qs from 'qs';

export function getRequest(url, params = {}) {
  return axios({
    method: 'get',
    url,
    params
  });
}

export function postRequest(url, params = {}) {
  return axios({
    url,
    method: 'post',
    data: params,
    transformRequest: [
      data => {
        let newData = data;
        Object.keys(newData).forEach(key => {
          if (typeof newData[key] === 'object') {
            newData[key] = JSON.stringify(newData[key]); // 这里必须使用内置JSON对象转换
          }
        });
        newData = qs.stringify(newData); // 这里必须使用qs库进行转换
        return newData;
      }
    ]
  });
}
